<div>
  <button mat-raised-button color="primary" (click)="add()">Add map</button>
  <table mat-table [dataSource]="ds" class="adminTable">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Id</th>
      <td mat-cell *matCellDef="let r">{{r.id}}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let r">{{r.name}}</td>
    </ng-container>
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef>Category</th>
      <td mat-cell *matCellDef="let r">{{r.category}}</td>
    </ng-container>
    <ng-container matColumnDef="ord">
      <th mat-header-cell *matHeaderCellDef>Order</th>
      <td mat-cell *matCellDef="let r">{{r.ord}}</td>
    </ng-container>
    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef>URL</th>
      <td mat-cell *matCellDef="let r">{{r.url}}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let r">
        <button mat-button (click)="edit(r)">Edit</button>
        <button mat-button color="warn" (click)="delete(r)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayed"></tr>
    <tr mat-row *matRowDef="let row; columns: displayed"></tr>
  </table>
</div>